// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import VueI18n from 'vue-i18n'
import less from 'less'
import './global.less'
import store from './store'
import './core/lazy_use' // use lazy load components
import ExportAlert from './components/message/ExportAlert'
import ImportAlert from './components/message/ImportAlert'
import './views/Item/css/quill.core.css'
import './views/Item/css/quill.snow.css'
import './views/Item/css/quill.bubble.css'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import en_US from 'ant-design-vue/lib/locale-provider/en_US'
import axios from 'axios'

import sendEvent from '@ali/aes-tracker-plugin-event'
import AES from '@ali/aes-tracker'
import '@ali/aes-tracker-plugin-jserror'
import '@ali/aes-tracker-plugin-api'
import '@ali/aes-tracker-plugin-perf'
import '@ali/aes-tracker-plugin-longtask'
import '@ali/aes-tracker-plugin-tsl'
import '@ali/aes-tracker-plugin-pv'
import '@alife/mcms_crossborder-merchant-web_front_end'

AES.setConfig({
  pid: 'crossborder-merchant-web',
  user_type: '101',
})

Vue.component('exportAlert', ExportAlert)
Vue.component('importAlert', ImportAlert)

Vue.use(less)
Vue.use(VueI18n)

axios.defaults.withCredentials = true

Vue.config.productionTip = false
/* mock相关配置 */
process.env.Mock && require('./mock.js')
/* i18n相关配置 */
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh_CN',
  messages: {
    'zh_CN': require('@alife/mcms_crossborder-merchant-web_front_end/zh-cn'),
    'en_US': require('@alife/mcms_crossborder-merchant-web_front_end/en-us'),
    'in_ID': require('@alife/mcms_crossborder-merchant-web_front_end/in-id'),
    'th_TH': require('@alife/mcms_crossborder-merchant-web_front_end/th-th'),
    'vi_VN': require('@alife/mcms_crossborder-merchant-web_front_end/vi-vn')
  }
})
export default i18n
Vue.use(i18n)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  data () {
    return {
      zh_CN,
      en_US
    }
  },
  computed: {
    locale () {
      return i18n.locale === 'zh_CN' ? this.zh_CN : this.en_US
    }
  },
  template: '<a-locale-provider :locale="locale"><App/></a-locale-provider>'
})



// WEBPACK FOOTER //
// ./src/main.js